export default {
  setLoading(state, loading) {
    state.loading = loading;
  },
  setUploadProgress(state, uploadProgress) {
    state.uploadProgress = uploadProgress;
  },
  setOnUpload(state, onUpload) {
    state.onUpload = onUpload;
  },
  setInsertProgress(state, insertProgress) {
    state.insertProgress = insertProgress;
  },
  setInsertName(state, insertName) {
    state.insertName = insertName;
  },
  setOnInsert(state, onInsert) {
    state.onInsert = onInsert;
  },
  setIntervalImport(state, payload) {
    state.intervalImport = payload;
  },
  setImportData(state, payload) {
    state.importId = payload.import_id;
    state.countData = payload.count_data;
  },
  clearFailedImport(state) {
    state.hasFailedImport = false;
    state.failedImportController = '';
    state.failedImportDate = '';
  },
  setStateVariable(state, { payload, variable }) {
    state[variable] = payload;
  },
  clearLastResult(state) {
    state.countData = 0;
    state.countSuccess = 0;
    state.countFailed = 0;
    state.countDone = 0;
    state.countSame = 0;
    state.uploadProgress = 0;
    state.onUpload = false;
    state.insertProgress = 0;
    state.onInsert = false;
    state.insertName = '';
    state.intervalImport = null;
    state.importId = null;
    state.hasFailedImport = false;
    state.failedImportController = '';
    state.failedImportDate = '';
  },
  setCancelation(state, payload) {
    state.requestData = payload;
  },
  setFailedResponse(state, payload) {
    state.isFailedResponse = payload;
  },
  setIntervalInsert(state, payload) {
    state.intervalInsert = payload;
  },
  setShowProgressBar(state, payload) {
    state.showProgressBar = payload;
  },
  setProgressTitle(state, title) {
    state.progressTitle = title;
  },
  setProgressColor(state, color) {
    state.progressColor = color;
  },
  setPercentage(state, percentage) {
    state.percentage = percentage;
  },
  setClearProgress(state) {
    state.percentage = 0;
    state.progressTitle = "Processing Request";
    state.progressColor = "grey";
    state.isFailedResponse = false;
  }
};